import Crud from '../views/Professional/Crud'
import Entity from '../views/Professional/Add'

let routes = {
    path: '/professionals',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/professionals/add',
            name: 'NewProfessional',
            component: Entity,
            meta: {
                pageTitle: 'Profissional',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Adicionar Profissional',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/professionals/edit/:id?',
            name: 'EditProfessional',
            component: Entity,
            meta: {
                pageTitle: 'Profissional',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Editar Profissional',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/professionals',
            name: 'list-professionals',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Profissionais',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Profissionais',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
